import { parseResponse } from  '../../../helpers/api'
import client from '../../../client'
import _ from 'lodash';

export default {
    async getAll () {
        return client.v1.get(`/services/all`).then((response) => {
            return parseResponse(response)
        })
    },
    async getService (serviceId) {
        return client.v1.get(`/services/get`, {
            params: {
                id: serviceId
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async createService (serviceData) {
        return client.v1.post(`/services/create`, {
            code: _.get(serviceData, 'code'),
            title: _.get(serviceData, 'title'),
            price: _.get(serviceData, 'price'),
            currency: 'rub',
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async updateService (serviceData) {
        return client.v1.post(`/services/update`, {
            id: _.get(serviceData, 'id'),
            code: _.get(serviceData, 'code'),
            title: _.get(serviceData, 'title'),
            price: _.get(serviceData, 'price'),
            currency: 'rub',
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async deleteService (serviceId) {
        return client.v1.post(`/services/delete`, {
            id: serviceId
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async getClientServices (clientId) {
        return client.v1.get(`/services/get-client-services`, {
            params: {
                clientId: clientId
            }
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async addServiceToClient (clientService) {
        return client.v1.post(`/services/add-to-client`, {
            serviceId: clientService.serviceId,
            clientId: clientService.clientId,
            price: clientService.price,
            currency: 'rub'
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async updateClientService (clientService) {
        return client.v1.post(`/services/update-client-service`, {
            id: clientService.id,
            price: clientService.price,
            currency: 'rub'
        }).then((response) => {
            return parseResponse(response)
        })
    },
    async deleteClientService (clientServiceId) {
        return client.v1.post(`/services/delete-client-service`, {
            id: clientServiceId
        }).then((response) => {
            return parseResponse(response)
        })
    },
}